import { render, staticRenderFns } from "./CommonProperty.vue?vue&type=template&id=2e9a9c16&scoped=true&"
import script from "./CommonProperty.vue?vue&type=script&lang=js&"
export * from "./CommonProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a9c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9a9c16')) {
      api.createRecord('2e9a9c16', component.options)
    } else {
      api.reload('2e9a9c16', component.options)
    }
    module.hot.accept("./CommonProperty.vue?vue&type=template&id=2e9a9c16&scoped=true&", function () {
      api.rerender('2e9a9c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/workflow/components/propertySetting/CommonProperty.vue"
export default component.exports